import React from 'react';
import styles from './ribbon-text.module.css';

interface RibbonTextProps {
  text: string;
}

/**
 * Component to render text with ribbon through Contentful.
 * Due to the limitation to contentful, using dangerouslySetInnerHTML is the only possible way to archive the request.
 *
 * @example
 * // text value
 * Wir sind <span class="arrow-highlight pink">Problemlöser</span>
 *
 * @TODO : implementation is duplicated with RibbonText component
 */
const RibbonText: React.FC<RibbonTextProps> = ({ text }) => {
  return (
    // @TODO : check if the style is correct
    <h3 className="mindset-24 lg:mindset-40 text-primary-main inline-block">
      <div
        className={styles['ribbonText']}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </h3>
  );
};

export default RibbonText;
